(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marcus-kit-product"]) return;
  try {
    
  if (!customElements.get('marcus-kit')) {
    class MarcusKit extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.form = this.querySelector('form');
        this.idInput = this.querySelector('[data-variant-id]');
        this.addButton = this.querySelector('[data-add]');
        this.error = this.querySelector('[data-error]');
        this.status = this.querySelector('[data-status]');
        this.cartLink = this.querySelector('[data-cart-link]');
        this.inputs = Array.from(this.querySelectorAll('[data-option]'));
        this.gallery = this.querySelector('.mk-gallery');
        this.slides = Array.from(this.querySelectorAll('.mk-slide'));
        this.thumbs = Array.from(this.querySelectorAll('[data-slide]'));
        this.sizeDialog = this.querySelector('[data-size-dialog]');
        this.imageDialog = this.querySelector('[data-image-dialog]');
        this.sticky = this.querySelector('[data-sticky]');
        this.stickyAction = this.querySelector('[data-sticky-action]');
        this.busy = false;
        this.reviewCart = false;
        this.shirtChosen = false;
        this.querySelector('[data-native]').disabled = true;
        this.idInput.disabled = false;
        this.querySelectorAll('[data-option-group]').forEach(group => { group.disabled = false; });
        this.dataset.ready = 'true';
        this.inputs.forEach(input => input.addEventListener('change', () => {
          if (input.dataset.option === '1') this.shirtChosen = true;
          if (input.dataset.option === '0' && !this.shirtChosen) {
            const match = this.inputs.find(item => item.dataset.option === '1' && item.value === input.value);
            if (match) match.checked = true;
          }
          this.error.hidden = true;
          this.updateSelection(true);
        }, {signal}));
        const requested = new URL(window.location.href).searchParams.get('variant');
        const initial = this.config.variants.find(variant => String(variant.id) === requested);
        if (initial) {
          this.inputs.forEach(input => { input.checked = initial.options[Number(input.dataset.option)] === input.value; });
          this.shirtChosen = true;
        }
        this.updateSelection(false);
        this.form.addEventListener('submit', event => this.addToCart(event), {capture:true, signal});
        this.thumbs.forEach(button => button.addEventListener('click', () => {
          this.gallery.scrollTo({left:Number(button.dataset.slide) * this.gallery.clientWidth, behavior:this.motion()});
        }, {signal}));
        this.gallery.addEventListener('scroll', () => {
          const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.gallery.scrollLeft / this.gallery.clientWidth)));
          this.thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
          this.querySelector('[data-page]').textContent = String(index + 1);
        }, {passive:true, signal});
        this.querySelectorAll('[data-zoom-src]').forEach(button => button.addEventListener('click', () => {
          const image = this.querySelector('[data-full-image]');
          image.src = button.dataset.zoomSrc;
          image.alt = button.dataset.zoomAlt;
          this.imageDialog.showModal();
        }, {signal}));
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close(), {signal}));
        [this.sizeDialog, this.imageDialog].forEach(dialog => dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, {signal}));
        this.querySelectorAll('[data-guide-open]').forEach(button => button.addEventListener('click', () => {
          this.selectGuide(button.dataset.guideOpen);
          this.sizeDialog.showModal();
        }, {signal}));
        this.querySelectorAll('[data-guide-tab]').forEach(button => button.addEventListener('click', () => this.selectGuide(button.dataset.guideTab), {signal}));
        this.querySelectorAll('[data-jump]').forEach(button => button.addEventListener('click', () => this.jumpToBuy(), {signal}));
        this.stickyAction.addEventListener('click', () => {
          if (this.variant && this.variant.available && !this.busy) this.form.requestSubmit();
          else this.jumpToBuy();
        }, {signal});
        this.querySelectorAll('[data-drawer]').forEach(link => link.addEventListener('click', event => {
          if (this.openDrawer()) event.preventDefault();
        }, {signal}));
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.sticky.hidden = entries[0].isIntersecting;
        }, {threshold:0.05});
        this.visibilityObserver.observe(this.form);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.visibilityObserver?.disconnect();
        this.initialized = false;
      }
      motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      selectGuide(index) {
        this.querySelectorAll('[data-guide-panel]').forEach(panel => { panel.hidden = panel.dataset.guidePanel !== index; });
        this.querySelectorAll('[data-guide-tab]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideTab === index)));
      }
      jumpToBuy() {
        this.querySelector('.mk-buy').scrollIntoView({behavior:this.motion(), block:'start'});
        const first = this.inputs.find(input => input.dataset.option === '0');
        if (first) first.focus({preventScroll:true});
      }
      getOptions() {
        return [0, 1].map(index => this.inputs.find(input => Number(input.dataset.option) === index && input.checked)?.value);
      }
      updateSelection(updateUrl) {
        const selected = this.getOptions();
        this.variant = selected.every(Boolean) ? this.config.variants.find(variant => variant.options[0] === selected[0] && variant.options[1] === selected[1]) : null;
        this.idInput.value = this.variant ? this.variant.id : '';
        this.querySelector('[data-selection]').textContent = this.variant ? this.config.texts.hoodie + ': ' + selected[0] + ' · ' + this.config.texts.tee + ': ' + selected[1] : '';
        if (this.variant) {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {style:'currency', currency:this.config.currency}).format(this.variant.price / 100) + ' ' + this.config.currency;
          this.querySelector('[data-price]').textContent = amount;
          this.querySelector('[data-sticky-price]').textContent = amount;
          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', this.variant.id);
            window.history.replaceState({}, '', url);
          }
        }
        this.updateButton();
      }
      updateButton() {
        const t = this.config.texts;
        let label = t.add;
        let disabled = false;
        if (!this.config.available) { label = t.coming; disabled = true; }
        else if (this.variant && !this.variant.available) { label = t.unavailable; disabled = true; }
        else if (this.reviewCart) { label = t.review; }
        else if (this.busy) { label = t.adding; disabled = true; }
        this.addButton.textContent = label;
        this.addButton.disabled = disabled;
        this.stickyAction.textContent = this.reviewCart ? t.review : (this.variant?.available ? t.add : t.choose);
        this.stickyAction.disabled = this.busy;
      }
      showError(message) { this.error.textContent = message; this.error.hidden = false; }
      openDrawer() {
        if (document.querySelector('.Vtl-CartDrawer[aria-hidden="false"]')) return true;
        const trigger = document.querySelector('#shopify-section-header a.cart-link');
        if (!trigger) return false;
        trigger.addEventListener('click', event => event.preventDefault(), {once:true});
        trigger.click();
        return true;
      }
      async addToCart(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        if (this.reviewCart) { window.location.assign(this.config.cartUrl); return; }
        if (!this.variant) { this.showError(this.config.texts.choose); this.jumpToBuy(); return; }
        if (!this.variant.available) { this.showError(this.config.texts.unavailable); return; }
        this.busy = true;
        this.error.hidden = true;
        this.status.textContent = '';
        this.updateButton();
        let attempted = false;
        try {
          const options = this.getOptions();
          attempted = true;
          const response = await fetch(this.config.addUrl, {
            method:'POST', credentials:'same-origin',
            headers:{'Content-Type':'application/json', 'Accept':'application/json'},
            body:JSON.stringify({items:[{id:this.variant.id, quantity:1, properties:{'Hoodie':options[0], 'Playera':options[1]}}]})
          });
          let result;
          try { result = await response.json(); } catch (error) { throw new Error(this.config.texts.error); }
          if (!response.ok) {
            attempted = false;
            throw new Error(typeof result.description === 'string' ? result.description : this.config.texts.error);
          }
          const cartResponse = await fetch(this.config.cartUrl + '.js', {credentials:'same-origin', headers:{'Accept':'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.cart-link__count, .cart-count, [data-cart-count]').forEach(element => { element.textContent = cart.item_count; });
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true, detail:{cart}}));
          }
          this.status.textContent = this.config.texts.added;
          this.cartLink.hidden = false;
          this.openDrawer();
        } catch (error) {
          this.reviewCart = attempted;
          this.cartLink.hidden = !attempted;
          this.showError(error.message || this.config.texts.error);
        } finally {
          this.busy = false;
          this.updateButton();
        }
      }
    }
    customElements.define('marcus-kit', MarcusKit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrc-home-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mrc-home')) {
    customElements.define('mrc-home', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const sticky = this.querySelector('[data-sticky-buy]');
        const offer = this.querySelector('[data-hero-offer]');
        if (sticky && offer && 'IntersectionObserver' in window) {
          let offerPassed = false;
          let withinLaunch = true;
          const updateSticky = () => { sticky.hidden = !offerPassed || !withinLaunch; };
          this.observer = new IntersectionObserver((entries) => {
            offerPassed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
            updateSticky();
          }, { threshold: 0 });
          this.launchObserver = new IntersectionObserver((entries) => {
            withinLaunch = entries[0].isIntersecting;
            updateSticky();
          }, { threshold: 0, rootMargin: '-160px 0px 0px 0px' });
          this.observer.observe(offer);
          this.launchObserver.observe(this);
        }
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-mrc-cta]');
          if (!link) return;
          this.dispatchEvent(new CustomEvent('freaky:home-cta', {
            bubbles: true,
            detail: { product: this.dataset.product, placement: link.dataset.mrcCta }
          }));
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.launchObserver) this.launchObserver.disconnect();
        if (this.abortController) this.abortController.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tanjiro-doble-vista"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(customElements.get('tanjiro-kit')) return;
  class TanjiroKit extends HTMLElement {
    connectedCallback(){
      if(this.initialized) return;
      this.initialized=true;
      this.config=JSON.parse(this.querySelector('[data-config]').textContent);
      this.strings=this.config.strings;
      this.form=this.querySelector('.tj-form');
      this.select=this.querySelector('[data-size]');
      this.express=this.querySelector('[data-express]');
      this.variantInput=this.querySelector('[data-variant-id]');
      this.button=this.querySelector('[data-add]');
      this.error=this.querySelector('[data-error]');
      this.status=this.querySelector('[data-status]');
      this.cartLink=this.querySelector('[data-cart-link]');
      this.gallery=this.querySelector('[data-gallery]');
      this.slides=Array.from(this.gallery.querySelectorAll('.tj-slide'));
      this.index=0; this.busy=false; this.added=false; this.uncertain=false;
      this.abort=new AbortController(); const signal=this.abort.signal;
      this.classList.add('is-ready');
      this.form.addEventListener('submit', e=>this.add(e),{capture:true,signal});
      this.button.addEventListener('click', e=>this.add(e),{capture:true,signal});
      this.select.addEventListener('change',()=>this.choose(),{signal});
      this.express.addEventListener('change',()=>this.choose(),{signal});
      this.querySelectorAll('[data-jump]').forEach(b=>b.addEventListener('click',()=>this.jump(),{signal}));
      this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close(),{signal}));
      this.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}},{signal}));
      this.querySelectorAll('[data-open-guide]').forEach(b=>b.addEventListener('click',()=>{
        const type=b.dataset.openGuide;
        this.querySelector('[data-guide-kimono]').hidden=type!=='kimono';
        this.querySelector('[data-guide-playera]').hidden=type!=='playera';
        this.querySelector('[data-guide]').showModal();
      },{signal}));
      this.querySelectorAll('[data-zoom]').forEach(b=>b.addEventListener('click',()=>{
        const source=b.closest('figure').querySelector('img'),target=this.querySelector('[data-lightbox-image]');
        target.src=source.currentSrc||source.src;target.alt=source.alt||this.strings.photo;
        this.querySelector('[data-lightbox]').showModal();
      },{signal}));
      this.querySelector('[data-gallery-controls]').hidden=false;
      this.querySelector('[data-gallery-total]').textContent=this.slides.length;
      const thumbs=this.querySelector('[data-thumbs]');thumbs.replaceChildren();
      this.slides.forEach((slide,i)=>{
        const original=slide.querySelector('img'),b=document.createElement('button'),im=document.createElement('img');
        b.type='button';b.setAttribute('aria-label',this.strings.view_photo+' '+(i+1));b.setAttribute('aria-current',String(i===0));
        const thumbUrl=new URL(original.src,location.href);thumbUrl.searchParams.set('width','120');im.src=thumbUrl.href;im.alt='';im.loading='lazy';im.width=62;im.height=62;b.appendChild(im);
        b.addEventListener('click',()=>this.go(i),{signal});thumbs.appendChild(b);
      });
      this.querySelector('[data-prev]').addEventListener('click',()=>this.go(this.index-1),{signal});
      this.querySelector('[data-next]').addEventListener('click',()=>this.go(this.index+1),{signal});
      this.gallery.addEventListener('scroll',()=>{if(this.frame)cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{this.index=Math.round(this.gallery.scrollLeft/this.gallery.clientWidth);this.updateGallery();});},{passive:true,signal});
      this.sticky=this.querySelector('[data-sticky]');
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver(entries=>{for(const entry of entries)this.sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});
        this.observer.observe(this.form);
      }
      this.updateGallery();this.choose();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);this.initialized=false;}
    motion(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';}
    go(i){const target=Math.max(0,Math.min(this.slides.length-1,i));this.gallery.scrollTo({left:target*this.gallery.clientWidth,behavior:this.motion()});}
    updateGallery(){
      this.querySelector('[data-gallery-index]').textContent=this.index+1;
      this.querySelector('[data-prev]').disabled=this.index===0;
      this.querySelector('[data-next]').disabled=this.index>=this.slides.length-1;
      this.querySelectorAll('[data-thumbs] button').forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));
    }
    jump(){this.form.scrollIntoView({behavior:this.motion(),block:'center'});this.select.focus({preventScroll:true});}
    money(cents){return new Intl.NumberFormat('es-MX',{style:'currency',currency:this.config.currency||'MXN'}).format(cents/100)+' '+this.config.currency;}
    choose(){
      const delivery=this.express.checked?'Express · 3 días':'Estándar';
      this.variant=this.config.variants.find(v=>v.option1===this.select.value&&v.option2===delivery);
      this.variantInput.value=this.variant?this.variant.id:'';
      this.error.hidden=true;
      const base=this.variant?this.variant.price:this.config.basePrice;
      const total=base+(this.express.checked?this.config.expressSurcharge:0);
      this.querySelector('[data-price]').textContent=this.money(base);
      this.querySelector('[data-total]').textContent=this.money(total);
      this.querySelector('[data-sticky-total]').textContent=this.money(total);
      this.querySelector('[data-shipping-label]').textContent=this.express.checked?this.config.shipping.expressLabel:this.config.shipping.standardLabel;
      this.updateButton();
    }
    updateButton(){
      this.button.disabled=this.busy||(!this.added&&!this.uncertain&&!!this.variant&&!this.variant.available);
      this.button.textContent=this.busy?this.strings.adding:this.added||this.uncertain?this.strings.view_cart:this.strings.add;
    }
    showError(text){this.error.textContent=text;this.error.hidden=false;}
    openDrawer(){
      if(document.querySelector('.Vtl-CartDrawer[aria-hidden="false"]'))return true;
      const trigger=document.querySelector('#shopify-section-header a.cart-link');
      if(!trigger)return false;
      trigger.addEventListener('click',event=>event.preventDefault(),{once:true});
      trigger.click();return true;
    }
    async refreshCart(){
      try{
        const response=await fetch(this.config.cartUrl+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!response.ok)return;
        const cart=await response.json();
        document.querySelectorAll('.cart-link__count,.cart-count,[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
      }catch(e){}
    }
    async add(event){
      event.preventDefault();event.stopImmediatePropagation();
      if(this.busy)return;
      if(this.added||this.uncertain){this.cartLink.hidden=false;this.openDrawer();return;}
      if(!this.variant){this.showError(this.strings.choose_size);this.select.focus();return;}
      if(!this.variant.available){this.showError(this.strings.unavailable);return;}
      this.busy=true;this.error.hidden=true;this.status.textContent='';this.updateButton();
      let requestSent=false;
      try{
        requestSent=true;
        const response=await fetch(this.config.addUrl,{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:this.variant.id,quantity:1,properties:{
            [this.strings.kimono]:this.strings.unitalla,[this.strings.tee]:this.variant.option1,[this.strings.contents]:this.strings.kit_contents,[this.config.shipping.propertyName]:this.variant.option2
          }}]})
        });
        const data=await response.json();
        if(!response.ok){requestSent=false;throw new Error(typeof data.description==='string'?data.description:this.strings.add_error);}
        this.added=true;this.cartLink.hidden=false;this.select.disabled=true;this.express.disabled=true;
        await this.refreshCart();
        this.status.textContent=this.strings.success_prefix+this.variant.option1+this.strings.success_suffix;
        this.openDrawer();
      }catch(error){
        this.uncertain=requestSent&&!this.added;
        this.cartLink.hidden=!this.uncertain&&!this.added;
        this.showError(this.uncertain?this.strings.uncertain:error.message||this.strings.add_error);
      }finally{this.busy=false;this.updateButton();}
    }
  }
  customElements.define('tanjiro-kit',TanjiroKit);
})();

  } catch(e) { console.error(e); }
})();
})();
